// format from 2024-01-02T14:21:26.009232Z

import { returnRol } from "../utils/constants";

// to 02/01/2024 11:21:26 — en HORA LOCAL del navegador. El backend manda timestamptz
// UTC (Postgres); antes se formateaba con getUTC*() y las horas salían +3 (UTC en vez
// de hora argentina). Legacy de Voras/MySQL, donde las fechas naive "funcionaban".
export function formatDateString(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}


export function verifyRol(roles = []) {
  let rol = returnRol();
  return roles.includes(rol);
}

export function validarMail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}


export function validarDNI(dni) {
  var re = /^[0-9]{8}$/;
  return re.test(dni);
}

export function validarTelefono(telefono) {
  var re = /^[0-9]{8,15}$/;
  return re.test(telefono);
}

